var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banner != null && _vm.banner != '')?_c('footer',{staticClass:"footer-sponsor"},[_c('img',{attrs:{"src":_vm.getUrlBanner(),"alt":"Banner"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }